import { useState, useEffect } from 'react';
import CookieConsentBanner from '../common/CookieConsentBanner';

const COOKIE_CONSENT_KEY = 'cookieConsent';

const CookieConsent = () => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    try {
      const consent = localStorage.getItem(COOKIE_CONSENT_KEY);
      if (consent !== 'true') {
        setShowBanner(true);
      }
    } catch (error) {
      console.error('Could not access localStorage:', error);
      setShowBanner(true); // Fallback seguro
    }
  }, []);

  const handleAccept = () => {
    try {
      localStorage.setItem(COOKIE_CONSENT_KEY, 'true');
    } catch (error) {
      console.error('Could not write to localStorage:', error);
    }
    setShowBanner(false);
  };

  if (!showBanner) {
    return null;
  }

  return <CookieConsentBanner onAccept={handleAccept} />;
};

export default CookieConsent;
